module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$route.path.indexOf('_detail') === -1) ? _c('div', [_c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-autocomplete', {
    staticClass: "inline-input",
    attrs: {
      "fetch-suggestions": _vm.queryStoreSearch,
      "placeholder": "请输入店铺名称",
      "size": "mini"
    },
    on: {
      "select": _vm.storeSearch
    },
    model: {
      value: (_vm.currentShop),
      callback: function($$v) {
        _vm.currentShop = $$v
      },
      expression: "currentShop"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "daterange",
      "value-format": "yyyy/MM/dd",
      "placeholder": "选择日期范围",
      "size": "mini"
    },
    on: {
      "change": _vm.dateChange
    },
    model: {
      value: (_vm.create_time),
      callback: function($$v) {
        _vm.create_time = $$v
      },
      expression: "create_time"
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "订单号",
      "size": "mini"
    },
    model: {
      value: (_vm.identifier),
      callback: function($$v) {
        _vm.identifier = $$v
      },
      expression: "identifier"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.search
    },
    slot: "append"
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 24
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "售后单号",
      "size": "mini"
    },
    model: {
      value: (_vm.aftersales_bn),
      callback: function($$v) {
        _vm.aftersales_bn = $$v
      },
      expression: "aftersales_bn"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.aftersalesBnSearch
    },
    slot: "append"
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "售后状态",
      "size": "mini"
    },
    on: {
      "change": _vm.aftersalesStatusSelectHandle
    },
    model: {
      value: (_vm.aftersales_status),
      callback: function($$v) {
        _vm.aftersales_status = $$v
      },
      expression: "aftersales_status"
    }
  }, _vm._l((_vm.aftersalesStatusList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择售后类型",
      "size": "mini"
    },
    on: {
      "change": _vm.TypeHandle
    },
    model: {
      value: (_vm.aftersales_type),
      callback: function($$v) {
        _vm.aftersales_type = $$v
      },
      expression: "aftersales_type"
    }
  }, _vm._l((_vm.aftersalesTypeList), function(item, index) {
    return _c('el-option', {
      key: index,
      attrs: {
        "label": item.name,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "round": "",
      "size": "mini"
    },
    on: {
      "click": _vm.exportData
    }
  }, [_vm._v("导出")]), _vm._v(" "), _c('el-popover', {
    attrs: {
      "placement": "top-start",
      "width": "200",
      "trigger": "hover",
      "content": "导出任务会以队列执行，点击导出后，请至‘设置-导出列表’页面中查看及下载数据"
    }
  }, [_c('i', {
    staticClass: "el-icon-question",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  })])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.list,
      "height": _vm.wheight - 140,
      "element-loading-text": "数据加载中"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "create_time",
      "width": "160",
      "label": "创建时间"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm._f("datetime")(scope.row.create_time, 'yyyy-MM-dd hh:mm:ss')))])]
      }
    }], null, false, 2176513052)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "aftersales_bn",
      "width": "150",
      "label": "售后单号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "order_id",
      "width": "150",
      "label": "订单号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "item_name",
      "width": "160",
      "label": "标题"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "num",
      "width": "100",
      "label": "数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "aftersales_status",
      "label": "售后类型"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.aftersales_type == 'ONLY_REFUND') ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v("仅退款")]) : (scope.row.aftersales_type == 'REFUND_GOODS') ? _c('el-tag', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("退货退款")]) : (scope.row.aftersales_type == 'EXCHANGING_GOODS') ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("换货")]) : _vm._e()]
      }
    }], null, false, 905725285)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "aftersales_status",
      "label": "售后状态"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.aftersales_status == '0') ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "mini"
          }
        }, [_vm._v("待处理")]) : (scope.row.aftersales_status == '1') ? _c('el-tag', {
          attrs: {
            "size": "mini"
          }
        }, [_vm._v("处理中")]) : (scope.row.aftersales_status == '2') ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("已处理")]) : (scope.row.aftersales_status == '3') ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("已驳回")]) : (scope.row.aftersales_status == '4') ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "mini"
          }
        }, [_vm._v("已关闭")]) : _vm._e()]
      }
    }], null, false, 2084585988)
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remarks",
      "label": "备注"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('router-link', {
          attrs: {
            "to": {
              path: _vm.matchHidePage('detail'),
              query: {
                aftersales_bn: scope.row.aftersales_bn
              }
            }
          }
        }, [_c('span', [_vm._v(" 详情")])]), _vm._v(" "), _c('span', {
          staticStyle: {
            "cursor": "pointer"
          }
        }, [_c('a', {
          attrs: {
            "type": "primary"
          },
          on: {
            "click": function($event) {
              return _vm.remarksShow(scope.row)
            }
          }
        }, [_vm._v("备注")])])]
      }
    }], null, false, 861468312)
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.remarksName,
      "visible": _vm.marks,
      "width": "40%",
      "before-close": _vm.handleClose
    },
    on: {
      "update:visible": function($event) {
        _vm.marks = $event
      }
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form2,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "备注信息"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.form2.remarks),
      callback: function($$v) {
        _vm.$set(_vm.form2, "remarks", $$v)
      },
      expression: "form2.remarks"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.marks = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.subremarks
    }
  }, [_vm._v("确 定")])], 1)], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
    staticClass: "content-padded content-center"
  }, [_c('el-pagination', {
    attrs: {
      "background": "",
      "layout": "total, sizes, prev, pager, next",
      "current-page": _vm.params.page,
      "page-sizes": [10, 20, 50],
      "total": _vm.total_count,
      "page-size": _vm.params.pageSize
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      },
      "update:current-page": function($event) {
        return _vm.$set(_vm.params, "page", $event)
      }
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('router-view')], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7529acd5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7529acd5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/mall/aftersales/list.vue
// module id = 2830
// module chunks = 0